var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyorderUnsubmitted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Myorder_Unsubmitted"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Myorder_Unsubmitted",
    clipPath: "url(#clip-Myorder_Unsubmitted)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9862",
    "data-name": "Group 9862",
    transform: "translate(-7444.875 11211.57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_19642",
    "data-name": "Path 19642",
    transform: "translate(7445 -11211.445)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.875,0A6.875,6.875,0,1,1,0,6.875,6.875,6.875,0,0,1,6.875,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.875 1.5 C 3.911210060119629 1.5 1.5 3.911210060119629 1.5 6.875 C 1.5 9.838789939880371 3.911210060119629 12.25 6.875 12.25 C 9.838789939880371 12.25 12.25 9.838789939880371 12.25 6.875 C 12.25 3.911210060119629 9.838789939880371 1.5 6.875 1.5 M 6.875 0 C 10.67195987701416 0 13.75 3.07804012298584 13.75 6.875 C 13.75 10.67195987701416 10.67195987701416 13.75 6.875 13.75 C 3.07804012298584 13.75 0 10.67195987701416 0 6.875 C 0 3.07804012298584 3.07804012298584 0 6.875 0 Z",
    stroke: "none",
    fill: "#535353"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_19643",
    "data-name": "Path 19643",
    d: "M382.525,260.43H388.2",
    transform: "translate(7066.523 -11465)",
    fill: "none",
    stroke: "#535353",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyorderUnsubmitted);
export default __webpack_public_path__ + "static/media/Myorder_Unsubmitted.f19540552a60e5203bbdc679ccc8c68f.svg";
export { ForwardRef as ReactComponent };